import { Button, Spinner } from 'flowbite-react';
import React from "react";
import { useNavigate } from 'react-router-dom';

const customSideBarTheme = {
  "base": "group relative flex items-stretch justify-center text-center font-medium transition-all duration-200 active:scale-[0.97] focus:outline-none focus:ring-2 disabled:pointer-events-none disabled:opacity-50",
  "color": {
    "indigo":
      "text-accent-ink border border-transparent bg-accent shadow-sm enabled:hover:bg-accent/80 enabled:hover:shadow-md focus:ring-primary/30",
    "light":
      "text-ink/80 bg-panel border border-line enabled:hover:border-muted/40 enabled:hover:bg-raised/50 focus:ring-primary/20 dark:bg-transparent",
    "failure":
      "text-fixed-white border border-transparent bg-red-600 shadow-sm enabled:hover:bg-red-700 enabled:hover:shadow-md focus:ring-red-500/30",
  },
  "pill": {
    "off": "rounded-xl",
    "on": "rounded-full",
  },
};

export default function ButtonWrapper(props) {
  const navigate = useNavigate();
  const { variant = 'button', color = 'primary', text } = props;
  let colorBtn;
  if (color === 'default') {
    colorBtn = 'light'
  } else if (color === 'error') {
    colorBtn = 'failure'
  } else {
    colorBtn = 'indigo'
  }

  const { rootClass = '', loading } = props
  if (variant === 'link') {
    return (
      <div className={rootClass}>
        <Button
          {...props}
          color={colorBtn}
          theme={customSideBarTheme}
          onClick={() => navigate(props.to)}
        >
          {text}
        </Button>
      </div>
    )
  } else {
    return (
      <div className={rootClass}>
        <div className="relative inline-flex">
          <Button
            {...props}
            color={colorBtn}
            theme={customSideBarTheme}
          >
            <div className="flex flex-row gap-2">
              {loading &&
                <Spinner size="sm" aria-label="Alternate spinner button example" />
              }
              {!!props.icon && !loading && props.icon}
              {text}
            </div>
          </Button>
          {props.isIndicated &&
            <div className="flex absolute top-0 right-0 -mt-0.5 -mr-1">
              <span className="absolute inline-flex animate-ping">
                <span className="inline-flex rounded-full h-3 w-3 bg-red-400 opacity-75"></span>
              </span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
            </div>
          }

        </div>
      </div>
    )
  }

}